var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"globalButton",class:{
      modernCancel: _vm.type == 'cancel',
      white: _vm.type == 'white',
      positiveBtn: _vm.type == 'positive',
      negativeBtn: _vm.type == 'negative',
      neutralBtn: _vm.type == 'neutral',
      largeBtn: _vm.size == 'large',
      mediumBtn: _vm.size == 'medium',
      smallBtn: _vm.size == 'small',
    },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('eventPassed')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }